import { gerar_arquivo_de_migracao_da_situacao_do_aluno } from "./gerar-arquivo-de-migracao-da-situacao-do-aluno/index";

const migracao_da_situacao_do_aluno = [
  ...gerar_arquivo_de_migracao_da_situacao_do_aluno,
];

export { migracao_da_situacao_do_aluno };
